import request from "../../../helpers/request";
import { TRequestFilters } from "./types";

export const getAlertasAbertosWithFilters = async ({
  dataIni,
  dataFim,
  idDivisao,
  idRegional,
  idLoja,
  idGrupoMonitor,
  idEquipamento,
  manutencao,
}: TRequestFilters) => {
  const _dataIni = dataIni ? `&dataIni=${dataIni}T00:00:00` : "";
  const _dataFim = dataFim ? `&dataFim=${dataFim}T23:59:59` : "";
  const _idDivisao = idDivisao ? `&idDivisao=${idDivisao}` : "";
  const _idRegional = idRegional ? `&idRegional=${idRegional}` : "";
  const _idLoja = idLoja ? `&idLoja=${idLoja}` : "";
  const _idGrupoMonitor = idGrupoMonitor
    ? `&idGrupoMonitor=${idGrupoMonitor}`
    : "";
  const _idEquipamento = idEquipamento ? `&idEquipamento=${idEquipamento}` : "";
  const _manutencao = manutencao ? `&manutencao=${manutencao}` : "";

  const str = `${_dataIni}${_dataFim}${_idDivisao}${_idRegional}${_idLoja}${_idGrupoMonitor}${_idEquipamento}${_manutencao}`;
  const url = `${process.env.REACT_APP_API}/Alerta/GetAlertasFiltro?${str}`;
  const result = await request({ url });
  return result.data;
};
